//#region src/components/Header/Header.module.css
var e = "_header_1ijyw_1", t = { header: e };
//#endregion
export { t as default, e as header };
